module.exports = __webpack_public_path__ + "static/media/google.3c34f628.png";